import ProtectedComponent from './protected-component.js';

const STORAGE_KEY = 'add-group-cta-dismissed';

/**
 * Invite users to create a group (mirrors add-friend-cta playful banner).
 */
class AddGroupCTA extends ProtectedComponent {
  constructor() {
    super();
    this.isDismissed = false;
  }

  connectedCallback() {
    super.connectedCallback();
    try {
      this.isDismissed = localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (_e) {
      this.isDismissed = false;
    }
    if (this.currentUser && !this.isDismissed) {
      this.render();
      this.attachEventListeners();
    }
    this.handleRoute = () => {
      if (!this.currentUser || this.isDismissed) return;
      this.render();
      this.attachEventListeners();
    };
    document.addEventListener('route-changed', this.handleRoute);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('route-changed', this.handleRoute);
  }

  setCurrentUser(user) {
    super.setCurrentUser(user);
    if (user && !this.isDismissed) {
      this.render();
      this.attachEventListeners();
    } else if (!user) {
      this.innerHTML = '';
    }
  }

  attachEventListeners() {
    const dismiss = this.querySelector('[data-dismiss-cta]');
    if (dismiss) {
      dismiss.addEventListener('click', () => {
        try {
          localStorage.setItem(STORAGE_KEY, 'true');
        } catch (_e) { /* ignore */ }
        this.isDismissed = true;
        this.innerHTML = '';
      });
    }
    const open = this.querySelector('[data-open-create-group]');
    if (open) {
      open.addEventListener('click', () => {
        if (window.router?.navigate) {
          window.router.navigate('/groups/new');
        } else {
          window.location.href = '/groups/new';
        }
      });
    }
  }

  render() {
    if (!this.currentUser || this.isDismissed) {
      return;
    }
    this.innerHTML = `
      <section class="add-group-cta" aria-label="Create a group">
        <button type="button" class="add-group-cta-dismiss" data-dismiss-cta aria-label="Dismiss">&times;</button>
        <div class="add-group-cta-inner">
          <span class="add-group-cta-mascot" aria-hidden="true">🌱</span>
          <div class="add-group-cta-text">
            <h2 class="add-group-cta-title">Plant a little community</h2>
            <p class="add-group-cta-desc">Start a group for your garden club, game night crew, or neighborhood pals.</p>
            <button type="button" class="btn btn-primary add-group-cta-btn" data-open-create-group>
              Create a group
            </button>
          </div>
        </div>
      </section>
    `;
  }
}

customElements.define('add-group-cta', AddGroupCTA);
export default AddGroupCTA;
